<template>
  <div>...</div>
</template>

<script>
export default {
  name: 'ImageAspectRatio'
}
</script>